<script>
import { layoutComputed } from "@/state/helpers";

/**
 * Horizontal-layout
 */
export default {
  data() {
    return {};
  },
  computed: {
    ...layoutComputed,
    noti: function(){
      let arr = this.$store.getters['sale/noti'];
      if(typeof arr == 'undefined' || !arr || arr.length < 1) return [];
      return JSON.parse(JSON.stringify(arr)).reverse()
    },
    currentUser: function(){
      var currentUser = this.$store.getters['auth/currentUser'];
      return currentUser;
    },
  },
  created: () => {
    document.body.setAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-sidebar");
    document.body.removeAttribute("data-layout-size");
    document.body.classList.remove("auth-body-bg");
  },
  methods: {
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
  },
  mounted() {}
};
</script>

<template>
  <div>
    <header id="page-topbar">
      <div class="navbar-header">
        <div class="d-flex">
          <div class="navbar-brand-box">
            <router-link to="/" class="logo logo-light"><img src="@/assets/images/logo.png" alt height="22" /></router-link>
          </div>
        </div>

        <div class="d-flex">

          <b-dropdown right variant="black" toggle-class="header-item">
            <template v-slot:button-content>
              <img
                class="rounded-circle header-profile-user"
                src="@/assets/images/users/avatar-1.png"
                alt="Header Avatar"
              />
              <span class="d-xl-inline-block ms-1">{{currentUser.name || ''}}</span>
              <i class="mdi mdi-chevron-down d-xl-inline-block"></i>
            </template>
            <b-dropdown-divider></b-dropdown-divider>
            <a href="/sale" class="dropdown-item"><i class="bx bx-basket font-size-16 align-middle me-1" ></i> Mở POS bán hàng </a>
            <router-link to="/session" class="dropdown-item"><i class="bx bx-calendar font-size-16 align-middle me-1" ></i> Phiên bán hàng </router-link>
            <router-link to="/" class="dropdown-item"><i class="bx bx-grid-alt font-size-16 align-middle me-1" ></i> Danh sách đơn hàng </router-link>
            <router-link to="/hbcod" class="dropdown-item"><i class="bx bx-grid-alt font-size-16 align-middle me-1" ></i>Thu hồi COD </router-link>
            <router-link to="/hbpos" class="dropdown-item"><i class="bx bx-grid-alt font-size-16 align-middle me-1" ></i>Thu hồi POS </router-link>
            <router-link to="/eorder" class="dropdown-item"><i class="bx bx-grid-alt font-size-16 align-middle me-1" ></i>Tra cứu đơn sàn </router-link>
            <a href="/logout" class="dropdown-item text-danger"><i class="bx bx-power-off font-size-16 align-middle me-1 text-danger" ></i> Đăng xuất </a>
          </b-dropdown>

        </div>
      </div>
    </header>
      <div style="width: 100%; max-width: 1500px; margin: 60px auto 0px; padding: 0px 15px;"><slot /></div>
  <div id="noti-box">
    <b-alert v-for="item in noti" :key="item.id" show dismissible :variant="item.type"><div style="font-weight: bold;" v-if="item.type == 'error' || item.type == 'danger'">LỖI!</div>{{item.text}}</b-alert>
  </div>
  </div>
</template>
